<template>

  <nav :style="navStyle" v-if="$store.state.displayFunctions.loginPageUnmounted">
    <div class="nav-container-one">
      <div class="logo-container">
        <h3 @click="()=>{reset() ;handleActiveLink('Home')} ">SoMedia</h3>

        <div class="search-main-container">

          <span class="search-icon-mobile-view" :style="searchZIndex" v-if="searchMobileView"
            @click="showSearchInput">&nbsp;
            <font-awesome-icon :icon="['fas', 'search']" />
          </span>


          <span class="search-icon  search-items" :style="searchZIndex">&nbsp;
            <font-awesome-icon :icon="['fas', 'search']" />
          </span>
          <span class="search-container" :style="searchZIndex">
            <input type="text" placeholder=" Search for Friends..." v-model="searchInput"
              @click="handleSearchBackDrop('open')" class="search-items" :style="searchZIndex">

          </span>
          <div class="search-contents" v-if="displaySearchContents">
            <ul v-for="user in filteredSearchList" :key="user.userName">
              <li @click="showUserTimeline(user.userName)">
                <img :src="$store.state.users[user.userName].userProfileImage" alt="">
                <span class="names-Bold"> {{user.userName}}</span>
              </li>
            </ul>
            <div v-if="searchNotFound" style="text-align:center">User Not Found</div>
          </div>
        </div>
      </div>

      <ul class="website-info">
        <li> <a href="https://www.linkedin.com/in/uche-okoroafor-a9286b19b" target="_blank">About</a>&nbsp;
          <font-awesome-icon :icon="['fas', 'info']" />
        </li>
        <li> <a href="https://www.linkedin.com/in/uche-okoroafor-a9286b19b" target="_blank">Contact</a>&nbsp;
          <font-awesome-icon :icon="['fas', 'phone-square-alt']" />
        </li>
        <li>

          <button @click="handleLogin('')" class="btn btn-danger m-1" v-if="logout">LogOut
            <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
          </button>
          <button @click="handleLogin('login')" class="btn btn-success m-1" v-if="updateUserData">LogIn
            <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
          </button>
        </li>

      </ul>


      <div class="user-icon" v-if="userIconMenu">


        <span ref="userImageMobileView" class="userImage  username-header"
          @click="handleUserOwnMenu('userImageMobileView')"> <img :src="userData.userProfileImage" alt="">&nbsp;
          <span class="names-Bold">{{userData.userName}}</span> &nbsp;
          <font-awesome-icon :icon="['fas', 'sort-down']" v-if="dropIconDisplay" ref="sortDown" />
          <font-awesome-icon :icon="['fas', 'sort-up']" v-if="!dropIconDisplay" ref="sortUp" />
          <div class="dropdown-OwnMenu" ref="userOwnMenuMobileView">
            <font-awesome-icon :icon="['fas', 'sort-up']" class="pointer-part" />

            <ul>
              <li @click="showFriends()">Your Friends</li>
              <li @click="showFriends()">Your Followers</li>
              <li @click="showFriends()"> Following</li>
              <li @click="'chats'">Chats</li>
              <li class=" own-profile" ref="profile" @click="handlePushRoutes('userProfile')">

                My Profile

                &nbsp;
                <font-awesome-icon :icon="['fas', 'user']" ref="profileIcon" />
              </li>
              <li class="login-btns">
                <button @click="handleLogin('')" class="btn btn-danger m-1" v-if="logout">LogOut
                  <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
                </button>
                <button @click="handleLogin('login')" class="btn btn-success m-1" v-if="updateUserData">LogIn
                  <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
                </button>
              </li>
            </ul>
          </div>

        </span>

      </div>

    </div>


    <div class="nav-container-two">

      <ul class="home-list">
        <li ref="home" @click="()=>{handlePushRoutes('Home'); handleActiveLink('Home')}" :style="homeLink"
          class="lists"><span :class="handleTextHover('Home')">Home
            <font-awesome-icon :icon="['fas', 'home']" ref="homeIcon" /> &nbsp;
          </span>
        </li>
        <li class="lists nav-newsFeed" :style="newsFeedLink" ref="newsFeed"
          @click="()=>{handlePushRoutes('Newsfeed');handleActiveLink('Newsfeed')}"><span
            :class="handleTextHover('Newsfeed')">Newsfeed
            <font-awesome-icon :icon="['fas', 'newspaper']" ref="newsFeedIcon" />&nbsp;
          </span><span class="show-counter" v-if="timelineCount? true:false">{{timelineCount}}</span>
        </li>

        <li class="lists" :style="timelineLink" ref="timeline" @click="handlePushRoutes('Timeline')"><span
            :class="handleTextHover('Timeline')">Timeline
            <font-awesome-icon :icon="['fas', 'user-clock']" ref="timelineIcon" />&nbsp;
          </span>
        </li>
        <li class="lists nav-profile" :style="profileLink" ref="profile" @click="handlePushRoutes('userProfile')">
          <span :class="handleTextHover('userProfile')">Profile
            <font-awesome-icon :icon="['fas', 'user']" ref="profileIcon" />&nbsp;
          </span>
        </li>
        <li class="lists" :style="messageLink" ref="messages" @click="handlePushRoutes('Messages')"> <span
            :class="handleTextHover('Messages')">Messages
            <font-awesome-icon :icon="['fas', 'envelope']" ref="messageIcon" />
          </span> <span class="show-counter-messages" v-if="newMessageCount? true:false">{{newMessageCount}}</span>
        </li>
        <li class="lists collapsed-nav-notification" ref="notificationsFullNav"
          @click="handleNotifications('notificationsFullNav')">
          <span class="nav-notification-hover">Notifications
            <font-awesome-icon :icon="['fas', 'bell']" ref="notificationIcon" />
          </span>
          <span class="show-counter-notification" v-if="notificationCount? true:false">{{notificationCount}}</span>

          <div class="dropdown-notifications" ref="notificationMenuFullNav">
            <font-awesome-icon :icon="['fas', 'sort-up']" class="pointer-part" />
            <ul v-for="notification in notifications" :key="notification.notificationId">

              <li ref="lists" @click="showNotificationDetails('post',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'post' && notification.notificationStatus === 'unRead'">
                Your friend <span class="names-Bold">{{notification.userName}}</span> just made a new
                {{notification.notificationType}}
                <font-awesome-icon :icon="['fas', 'newspaper']" /><br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>

              <li ref="lists"
                @click="showNotificationDetails('friend request',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'friend request' && notification.notificationStatus === 'unRead'">
                <span class="names-Bold">{{notification.userName}}</span> sent you a {{notification.notificationType}}
                <font-awesome-icon class="ml-2" :icon="['fas', 'user-friends']" />
                <br> <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>
              <li ref="lists"
                @click="showNotificationDetails('Accepted Friend Request',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'Accepted Friend Request' && notification.notificationStatus === 'unRead'">
                <span class="names-Bold">{{notification.userName}}</span> Accpted Your Friend request
                <font-awesome-icon class="ml-2" :icon="['fas', 'user-friends']" />
                <br> <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>
              <li ref="lists"
                @click="showNotificationDetails('message',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'message' && notification.notificationStatus === 'unRead'">
                You have a new {{notification.notificationType}} from <span class="names-Bold">{{notification.userName}}
                  <font-awesome-icon class="ml-2" :icon="['fas', 'envelope']" />
                </span> <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>

              <li ref="lists"
                @click="showNotificationDetails('likes',notification.notificationId,notification.posterUserName)"
                v-if="notification.notificationType === 'likes' && notification.notificationStatus === 'unRead'&& notification.posterUserName === userData.userName ">
                <span class="names-Bold">{{notification.userName}}</span> likes your post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /><br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


              <li ref="lists"
                @click="showNotificationDetails('likes',notification.notificationId,notification.userName,notification.posterUserName)"
                v-if="notification.notificationType === 'likes' && notification.notificationStatus === 'unRead'&& notification.userName !== notification.posterUserName && notification.posterUserName !== userData.userName">
                Your friend <span class="names-Bold">{{notification.userName}}</span> likes <span
                  class="names-Bold">{{notification.posterUserName}}</span>'s post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /><br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


              <li ref="lists"
                @click="showNotificationDetails('likes',notification.notificationId,notification.userName,notification.posterUserName)"
                v-if="notification.notificationType === 'likes' && notification.notificationStatus === 'unRead'&& notification.userName === notification.posterUserName && notification.posterUserName !== userData.userName">
                Your friend <span class="names-Bold">{{notification.userName}}</span> likes <span
                  class="names-Bold">{{handleGender(notification.userName)}}</span> post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /> <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>






              <li ref="lists"
                @click="showNotificationDetails('likedComment',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'likedComment' && notification.notificationStatus === 'unRead'&& notification.commenterUserName === userData.userName && notification.posterUserName !== userData.userName && notification.posterUserName !== notification.userName && notification.commenterUserName !== notification.userName">
                <span class="names-Bold">{{notification.userName}}</span> likes your comment on <span
                  class="names-Bold">{{notification.posterUserName}}</span>'s post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /><br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


              <li ref="lists"
                @click="showNotificationDetails('likedComment',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'likedComment' && notification.notificationStatus === 'unRead'&& notification.commenterUserName === notification.userName && notification.userName !== userData.userName  && notification.posterUserName !== notification.userName">
                <span class="names-Bold">{{notification.userName}}</span> likes {{handleGender(notification.userName)}}
                comment on <span class="names-Bold">{{notification.posterUserName}}</span>'s post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /><br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


              <li ref="lists"
                @click="showNotificationDetails('likedComment',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'likedComment' && notification.notificationStatus === 'unRead'&& notification.commenterUserName === userData.userName && notification.posterUserName === userData.userName && notification.posterUserName !== notification.userName">
                <span class="names-Bold">{{notification.userName}}</span> likes your comment on Your post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /> <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


              <li ref="lists"
                @click="showNotificationDetails('likedComment',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'likedComment' && notification.notificationStatus === 'unRead'&& notification.commenterUserName !== userData.userName && notification.posterUserName === userData.userName && notification.posterUserName !== notification.userName">
                <span class="names-Bold">{{notification.userName}}</span> likes {{notification.commenterUserName}}
                comment on Your post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /> <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>

              <li ref="lists"
                @click="showNotificationDetails('likedComment',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'likedComment' && notification.notificationStatus === 'unRead'&& notification.commenterUserName === notification.userName && notification.posterUserName !== userData.userName && notification.posterUserName === notification.userName">
                <span class="names-Bold">{{notification.userName}}</span> likes {{handleGender(notification.userName)}}
                comment on {{handleGender(notification.userName)}} post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /> <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>




              <li ref="lists"
                @click="showNotificationDetails('comment',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'comment' && notification.notificationStatus === 'unRead'&& notification.posterUserName === userData.userName && notification.userName !== userData.userName">
                <span class="names-Bold">{{notification.userName}}</span> commented on your post <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


              <li ref="lists"
                @click="showNotificationDetails('comment',notification.notificationId,notification.userName,notification.posterUserName)"
                v-if="notification.notificationType === 'comment' && notification.notificationStatus === 'unRead'&& notification.userName !== userData.userName && notification.userName !== notification.posterUserName && userData.userName !== notification.posterUserName">
                Your friend
                <span class="names-Bold">{{notification.userName}}</span> commented on <span
                  class="names-Bold">{{notification.posterUserName}}</span>'s post <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>

              <li ref="lists"
                @click="showNotificationDetails('comment',notification.notificationId,notification.userName,notification.posterUserName)"
                v-if="notification.notificationType === 'comment' && notification.notificationStatus === 'unRead'&& notification.userName !== userData.userName && notification.userName === notification.posterUserName">
                Your friend
                <span class="names-Bold">{{notification.userName}}</span> commented on
                {{handleGender(notification.userName)}} post <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>



              <li ref="lists"
                @click="showNotificationDetails('follow',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'follow' && notification.notificationStatus === 'unRead' && notification.userName !== userData.userName">
                <span class="names-Bold">{{notification.userName}}</span> started following you
                <font-awesome-icon class="ml-2" :icon="['fas', 'users']" /><br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


            </ul>
            <span v-if="!notificationCount? true:false">You have no new Notification</span>

          </div>
        </li>





      </ul>

      <div class="user-icon">


        <span ref="userImageFullNav" class="userImage" @click="handleUserOwnMenu('userImageFullNav')"> <img
            :src="userData.userProfileImage" alt="">&nbsp;<span class="names-Bold">
            {{userData.userName}}</span>&nbsp;
          <font-awesome-icon :icon="['fas', 'sort-down']" v-if="dropIconDisplay" ref="sortDown" />
          <font-awesome-icon :icon="['fas', 'sort-up']" v-if="!dropIconDisplay" ref="sortUp" />

          <div class="dropdown-OwnMenu" ref="userOwnMenuFullNav">
            <font-awesome-icon :icon="['fas', 'sort-up']" class="pointer-part" />

            <ul>
              <li @click="showFriends">Your Friends</li>
              <li @click="showFriends">Your Followers</li>
              <li @click="showFriends"> Following</li>
              <li @click="'chats'">Chats</li>
            </ul>
          </div>

        </span>

      </div>

    </div>

    <div class="back-drop" v-if="backDrop" @click="handleUserOwnMenu(clickedMenu)"></div>
    <div class="search-back-drop" v-if="searchBackDrop" @click="handleSearchBackDrop('close')"></div>
    <div class="notify-back-drop" v-if="notificationBackDrop" @click="handleNotifyBackDrop"></div>
    <div class="nav-menu-bar-drop" v-if="menuBarBackDrop" @click="handleMenuBarBackDrop"></div>



  </nav>



  <div class="collapsed-nav" :style="collapsedNav" v-if="$store.state.displayFunctions.loginPageUnmounted">
    <div class="back-drop" v-if="backDrop" @click="handleUserOwnMenu(clickedMenu)"></div>
    <div class="search-back-drop" v-if="searchBackDrop" @click=" handleSearchBackDrop('close')"></div>
    <div class="notify-back-drop" v-if="notificationBackDrop" @click="handleNotifyBackDrop"></div>
    <div class="nav-menu-bar-drop" v-if="menuBarBackDrop" @click="handleMenuBarBackDrop"></div>




    <div class="logo-container">
      <h3 @click=" handleActiveLink('Home')">SoMedia</h3>

      <div class="search-main-container">

        <span class="search-icon-mobile-view" :style="searchZIndex" v-if="searchMobileView"
          @click="showSearchInput">&nbsp;
          <font-awesome-icon :icon="['fas', 'search']" />
        </span>


        <span class="search-icon search-items" :style="searchZIndex">&nbsp;
          <font-awesome-icon :icon="['fas', 'search']" />
        </span>

        <span class="search-container search-items" :style="searchZIndex">
          <input type="text" placeholder=" Search for Friends..." v-model="searchInput"
            @click="handleSearchBackDrop('open')">
        </span>
        <div class="search-contents" v-if="displaySearchContents">
          <ul v-for="user in filteredSearchList" :key="user.userName">
            <li @click="showUserTimeline(user.userName)">
              <img :src="$store.state.users[user.userName].userProfileImage" alt="">&nbsp;
              <span class="names-Bold">{{user.userName}}</span>
            </li>
          </ul>
          <div v-if="searchNotFound" style="text-align:center">User Not Found</div>
        </div>
      </div>
    </div>

    <div class="nav-container-two" v-if="displayNavTwo">
      <div class="collapsed-nav-menu-bar" @click="handleShowMenuContents">
        <font-awesome-icon :icon="['fas', 'bars']" />
        <div class="collapsed-nav-menu-contents" v-if="menuContents">
          <font-awesome-icon :icon="['fas', 'sort-up']" class="pointer-part" />

          <ul>
            <li class="" @click="()=>{handlePushRoutes('Newsfeed');handleActiveLink('Newsfeed')}"> <span
                class="">Newsfeed </span>
              <font-awesome-icon :icon="['fas', 'newspaper']" />

              <span class="show-counter" v-if="timelineCount? true:false">{{timelineCount}}</span>
            </li>
            <li class=" " @click="handlePushRoutes('Timeline')">
              <span class="">Timeline </span>
              <font-awesome-icon :icon="['fas', 'user-clock']" />
            </li>
            <li class="  " @click="handlePushRoutes('userProfile')">


              <span class=""> Profile </span>
              <font-awesome-icon :icon="['fas', 'user']" />
            </li>
            <li class="" @click="handlePushRoutes('Messages')"> <span class=""> Messages </span>
              <font-awesome-icon :icon="['fas', 'envelope']" /><span class="show-counter-messages  "
                v-if="newMessageCount? true:false">{{newMessageCount}}</span>
            </li>

          </ul>

        </div>

      </div>
      <ul class="home-list">
        <li ref="home" :style="homeLink" @click="()=>{handlePushRoutes('Home'); handleActiveLink('Home')}"
          class="lists list-mobile-view">
          <span class="collapsed-nav-text" :class="handleTextHover('Home')">Home </span>
          <font-awesome-icon :icon="['fas', 'home']" ref="homeIcon" />

        </li>
        <li class="lists list-mobile-view" :style="newsFeedLink" ref="newsFeed"
          @click="()=>{handlePushRoutes('Newsfeed');handleActiveLink('Newsfeed')}">
          <span class="collapsed-nav-text list-mobile-view " :class="handleTextHover('Newsfeed')">Newsfeed &nbsp;</span>
          <font-awesome-icon :icon="['fas', 'newspaper']" ref="newsFeedIcon" />

          <span class="show-counter" v-if="timelineCount? true:false">{{timelineCount}}</span>
        </li>

        <li class="lists  list-mobile-view" :style="timelineLink" ref="timeline" @click="handlePushRoutes('Timeline')">
          <span class="collapsed-nav-text " :class="handleTextHover('Timeline')">Timeline </span>

          <font-awesome-icon :icon="['fas', 'user-clock']" ref="timelineIcon" />
        </li>
        <li class="lists   list-mobile-view" :style="profileLink" ref="profile"
          @click="handlePushRoutes('userProfile')">


          <span class="collapsed-nav-text nav-profile " :class="handleTextHover('userProfile')">Profile </span>

          <font-awesome-icon :icon="['fas', 'user']" ref="profileIcon" />
        </li>
        <li class="lists list-mobile-view" :style="messageLink" ref="messages" @click="handlePushRoutes('Messages')">
          <span class="collapsed-nav-text " :class="handleTextHover('Messages')"> Messages </span>
          <font-awesome-icon :icon="['fas', 'envelope']" ref="messageIcon" />
          <span class="show-counter-messages  " v-if="newMessageCount? true:false">{{newMessageCount}}</span>
        </li>
        <li class="lists  collapsed-nav-notification" ref="notifications" @click="handleNotifications('notifications')">
          <span @click="handleNotifications('notifications')" class="collapsed-nav-text  nav-notification-hover">
            Notifications </span>

          <font-awesome-icon :icon="['fas', 'bell']" ref="notificationIcon" />

          <span class="show-counter-notification" v-if="notificationCount? true:false">{{notificationCount}}</span>

          <div class="dropdown-notifications  collapsed-dropdown" ref="notificationMenu">
            <font-awesome-icon :icon="['fas', 'sort-up']" class="pointer-part" />
            <ul v-for="notification in notifications" :key="notification.notificationId">
              <li ref="lists" @click="showNotificationDetails('post',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'post' && notification.notificationStatus === 'unRead'">
                Your friend <span class="names-Bold">{{notification.userName}}</span> just made a new
                {{notification.notificationType}}
                <font-awesome-icon :icon="['fas', 'newspaper']" ref="newsFeedIcon" /><br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>

              <li ref="lists"
                @click="showNotificationDetails('friend request',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'friend request' && notification.notificationStatus === 'unRead'">
                <span class="names-Bold">{{notification.userName}}</span> sent you a {{notification.notificationType}}
                <font-awesome-icon class="ml-2" :icon="['fas', 'user-friends']" />
                <br> <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>
              <li ref="lists"
                @click="showNotificationDetails('Accepted Friend Request',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'Accepted Friend Request' && notification.notificationStatus === 'unRead'">
                <span class="names-Bold">{{notification.userName}}</span> Accpted Your Friend request
                <font-awesome-icon class="ml-2" :icon="['fas', 'user-friends']" />
                <br> <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>
              <li ref="lists"
                @click="showNotificationDetails('message',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'message' && notification.notificationStatus === 'unRead'">
                You have a new {{notification.notificationType}} from <span class="names-Bold">{{notification.userName}}
                  <font-awesome-icon class="ml-2" :icon="['fas', 'envelope']" />
                </span> <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>

              <li ref="lists"
                @click="showNotificationDetails('likes',notification.notificationId,notification.posterUserName)"
                v-if="notification.notificationType === 'likes' && notification.notificationStatus === 'unRead'&& notification.posterUserName === userData.userName ">
                <span class="names-Bold">{{notification.userName}}</span> likes your post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /><br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


              <li ref="lists"
                @click="showNotificationDetails('likes',notification.notificationId,notification.userName,notification.posterUserName)"
                v-if="notification.notificationType === 'likes' && notification.notificationStatus === 'unRead'&& notification.userName !== notification.posterUserName && notification.posterUserName !== userData.userName">
                Your friend <span class="names-Bold">{{notification.userName}}</span> likes <span
                  class="names-Bold">{{notification.posterUserName}}</span>'s post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /><br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


              <li ref="lists"
                @click="showNotificationDetails('likes',notification.notificationId,notification.userName,notification.posterUserName)"
                v-if="notification.notificationType === 'likes' && notification.notificationStatus === 'unRead'&& notification.userName === notification.posterUserName && notification.posterUserName !== userData.userName">
                Your friend <span class="names-Bold">{{notification.userName}}</span> likes <span
                  class="names-Bold">{{handleGender(notification.userName)}}</span> post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /> <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>






              <li ref="lists"
                @click="showNotificationDetails('likedComment',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'likedComment' && notification.notificationStatus === 'unRead'&& notification.commenterUserName === userData.userName && notification.posterUserName !== userData.userName && notification.posterUserName !== notification.userName && notification.commenterUserName !== notification.userName">
                <span class="names-Bold">{{notification.userName}}</span> likes your comment on <span
                  class="names-Bold">{{notification.posterUserName}}</span>'s post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /><br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


              <li ref="lists"
                @click="showNotificationDetails('likedComment',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'likedComment' && notification.notificationStatus === 'unRead'&& notification.commenterUserName === notification.userName && notification.userName !== userData.userName  && notification.posterUserName !== notification.userName">
                <span class="names-Bold">{{notification.userName}}</span> likes {{handleGender(notification.userName)}}
                comment on <span class="names-Bold">{{notification.posterUserName}}</span>'s post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /><br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


              <li ref="lists"
                @click="showNotificationDetails('likedComment',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'likedComment' && notification.notificationStatus === 'unRead'&& notification.commenterUserName === userData.userName && notification.posterUserName === userData.userName && notification.posterUserName !== notification.userName">
                <span class="names-Bold">{{notification.userName}}</span> likes your comment on Your post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /> <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


              <li ref="lists"
                @click="showNotificationDetails('likedComment',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'likedComment' && notification.notificationStatus === 'unRead'&& notification.commenterUserName !== userData.userName && notification.posterUserName === userData.userName && notification.posterUserName !== notification.userName">
                <span class="names-Bold">{{notification.userName}}</span> likes {{notification.commenterUserName}}
                comment on Your post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /> <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>

              <li ref="lists"
                @click="showNotificationDetails('likedComment',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'likedComment' && notification.notificationStatus === 'unRead'&& notification.commenterUserName === notification.userName && notification.posterUserName !== userData.userName && notification.posterUserName === notification.userName">
                <span class="names-Bold">{{notification.userName}}</span> likes {{handleGender(notification.userName)}}
                comment on {{handleGender(notification.userName)}} post
                <font-awesome-icon :icon="['fas', 'thumbs-up']" /> <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>




              <li ref="lists"
                @click="showNotificationDetails('comment',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'comment' && notification.notificationStatus === 'unRead'&& notification.posterUserName === userData.userName && notification.userName !== userData.userName">
                <span class="names-Bold">{{notification.userName}}</span> commented on your post <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>


              <li ref="lists"
                @click="showNotificationDetails('comment',notification.notificationId,notification.userName,notification.posterUserName)"
                v-if="notification.notificationType === 'comment' && notification.notificationStatus === 'unRead'&& notification.userName !== userData.userName && notification.userName !== notification.posterUserName && userData.userName !== notification.posterUserName">
                Your friend
                <span class="names-Bold">{{notification.userName}}</span> commented on <span
                  class="names-Bold">{{notification.posterUserName}}</span>'s post <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>

              <li ref="lists"
                @click="showNotificationDetails('comment',notification.notificationId,notification.userName,notification.posterUserName)"
                v-if="notification.notificationType === 'comment' && notification.notificationStatus === 'unRead'&& notification.userName !== userData.userName && notification.userName === notification.posterUserName">
                Your friend
                <span class="names-Bold">{{notification.userName}}</span> commented on
                {{handleGender(notification.userName)}} post <br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>



              <li ref="lists"
                @click="showNotificationDetails('follow',notification.notificationId,notification.userName)"
                v-if="notification.notificationType === 'follow' && notification.notificationStatus === 'unRead' && notification.userName !== userData.userName">
                <span class="names-Bold">{{notification.userName}}</span> started following you
                <font-awesome-icon class="ml-2" :icon="['fas', 'users']" /><br>
                <span>{{showDate(notification.notificationDate)}}</span>
                <hr>
              </li>
            </ul>
            <span v-if="!notificationCount? true:false">You have no new Notification</span>

          </div>
        </li>

      </ul>
    </div>

    <div class="user-icon">


      <span ref="userImage" class="userImage" @click="handleUserOwnMenu"> <img :src="userData.userProfileImage"
          alt="">&nbsp;
        <span class="names-Bold">
          {{userData.userName}}</span>
        <font-awesome-icon :icon="['fas', 'sort-down']" v-if="dropIconDisplay" ref="sortDown" />
        <font-awesome-icon :icon="['fas', 'sort-up']" v-if="!dropIconDisplay" ref="sortUp" />


        <div class="dropdown-OwnMenu" :style="userOwnMenuStyle">
          <font-awesome-icon :icon="['fas', 'sort-up']" class="pointer-part" />

          <ul>
            <li @click="showFriends">Your Friends</li>
            <li @click="showFriends">Your Followers</li>
            <li @click="showFriends"> Following</li>
            <li @click="'chats'">Chats</li>
            <li class=" own-profile" ref="profile" @click="handlePushRoutes('userProfile')">

              My Profile

              &nbsp;
              <font-awesome-icon :icon="['fas', 'user']" ref="profileIcon" />
            </li>

            <li class="login-btns">
              <button @click="handleLogin('')" class="btn btn-danger " v-if="logout">LogOut
                <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
              </button>
              <button @click="handleLogin('login')" class="btn btn-success " v-if="updateUserData">LogIn
                <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
              </button>
            </li>


          </ul>
        </div>

      </span>

    </div>




  </div>


  <div class="restrict-Guest" v-if="restrictGuest" @click="closeRestrictMessage">

    <div class="restrict-Guest-contents">
      <div class="close-restrict-message " @click="closeRestrictMessage">
        <font-awesome-icon :icon="['fas', 'times-circle']" class="color-danger" />
      </div>
      <span class="mt-4">Login Or Create an Account to Have Access to this<span style="white-space:nowrap;"> Link
          !</span>
        <br>
        <br>
        <span class="signin-button btn btn-success h-1 mb-1" @click="handleLogin('login')">Sign In
          <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
        </span>
      </span>

    </div>

  </div>
  <router-view />
  <AutoUsers />
  <audio id="newAlert" style="visibility: hidden;" preload="auto">
    <source :src="require('/src/assets/notificationSound/pristine-609.mp3')" type="audio/mp3">
    <source :src="require('/src/assets/notificationSound/pristine-609.ogg')" type="audio/ogg">
  </audio>

  <Footer v-if="handleFooterDisplay()" />

</template>

<script>
  import moment from "moment"
  import AutoUsers from "./components/AutoUsers.vue"
  import Footer from "./components/Footer.vue"
  import { uuid } from "vue-uuid";


  export default {
    name: "App",
    components: { Footer, AutoUsers },
    data() {
      return {

        userData: {

        },
        storeData: {},
        login: true,
        logout: false,
        userOwnMenu: false,
        userOwnMenuFullNav: false,
        userOwnMenuMobileView: false,
        searchInput: '',
        dropIconDisplay: true,
        friendsList: [],
        notifications: [],
        notificationCount: '',
        newMessageCount: 0,
        timelineCount: 0,
        homeLink: "background-color: var(--pink);color:var(--nave-blue)!important;font-weight: bolder;",
        profileLink: '',
        timelineLink: '',
        messageLink: '',
        newsFeedLink: '',
        notificationLink: '',
        activeLink: "background-color: var(--pink);color:var(--nave-blue)!important;font-weight: bolder;",
        inActiveLink: "background-color: var(--nave-blue);",
        backDrop: false,
        searchBackDrop: false,
        clickedMenu: "",
        allUsers: [],
        filteredSearchLists: [],
        displaySearchContents: false,
        searchZIndex: "z-index:0",
        notificationBackDrop: false,
        navStyle: "display:block",
        collapsedNav: "display:none",
        userOwnMenuStyle: "display:none;height:0;transition:all 1s",
        restrictGuest: false,
        userIconMenu: true,
        searchMobileView: true,
        displayNavTwo: true,
        menuContents: false,
        menuBarBackDrop: false,
        userIsActive: "",
        clickedLink: "Home",
        soundNum: 0,
        autoPostCounter: 0,
      }
    },

    beforeMount() {
      this.handleUserData()
    },

    mounted() {
      window.addEventListener('scroll', () => this.handleCollapseNav());
      this.handleUserData()
      window.addEventListener('mousemove', () => this.userIsActive = Date.now()
      )
    },
    beforeUnmount() {
      window.removeEventListener('scroll', () => this.handleCollapseNav());
      this.handleUserData()
      window.addEventListener('mousemove', () => this.userIsActive = Date.now())

    },


    methods: {

      handleUserData() {
        this.handleActiveLink(this.$store.state.displayFunctions.activeLink)
        if (localStorage.state === undefined) {
          this.$store.dispatch("handleUpdateLocalStorage", {
            params: "loadData"
          });
        } else {
          this.$store.dispatch("handleUpdateLocalStorage", {
            params: "retrieveData"
          });

        }

        const onlineTime = Date.now() - this.userIsActive;
        const onlineMinutes = Math.round(onlineTime / (1000 * 60));
        if (localStorage.userData !== undefined) {
          let userData = JSON.parse(localStorage.userData)

          if (userData.userName && onlineMinutes >= 5) {
            this.$store.dispatch("handleLogin", {
              userName: userData.userName, status: "online"
            })
            this.$store.dispatch("handleDisplayFunctions", {
              loginPageUnmounted: true,
              params: "loginPageUnMount"
            });
          }

        }
        else {

          let userData = {
            userName: '',
            loginTime: ''
          }
          localStorage.userData = JSON.stringify(userData)
          this.$router.push({ name: "Login" });
          this.handleActiveLink("Home")

        }
      },

      reset() {
        delete localStorage.state
        delete localStorage.userData




      },





      handleCollapseNav() {
        if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {

          this.$store.dispatch("handleDisplayFunctions", {
            navCollapsed: true,
            params: "collapseNav"
          });

          this.navStyle = "display:none"
          this.collapsedNav = "display:flex"
        } else {



          this.$store.dispatch("handleDisplayFunctions", {
            navCollapsed: false,
            params: "collapseNav"
          });

          this.navStyle = "display:block"
          this.collapsedNav = "display:none"

        }

      },

      showUserTimeline(userName) {

        if (this.userData.userName === "Guest") {

          return this.restrictGuest = true
        }

        this.handleSearchBackDrop("close")

        this.$router.push({
          name: "Timeline",
          params: { userName: userName, Timeline: "Timeline" },
        });

      },

      handleLogin(params) {
        if (params) {

          this.handleActiveLink("Home")
          return this.$router.push({ name: "Login" });
        }
        this.soundNum = 0

        let userData = {
          userName: '',
          loginTime: ''
        }
        this.$store.dispatch("handleDisplayFunctions", {
          newAccount: false,
          params: "newAccount"
        });

        this.$router.push({ name: "Login" });

        this.login = true
        this.logout = false
        this.$router.push({ name: "Login" });
        this.handleActiveLink("Home")



        setTimeout(() => {

          this.$store.dispatch("updateUserData", {
            Guest: {
              userName: "Guest",
              emailAddress: "",
              password: "",
              emailAddress: "",
              firstName: "",
              lastName: "",
              age: "",
              education: "",
              gender: "",
              videos: [],
              photos: [],
              address: "",
              emailAddress: "",
              postCode: "",
              country: "",
              city: "",
              aboutMe: "",
              messages: {},
              messageStatus: {},
              notifications: {},
              occupation: "",
              status: "online",
              posts: [],
              followers: [],
              following: [],
              friends: [],
              activities: {},
              postCode: "",

            },
          });


        }, 100);






      },

      handleShowMenuContents() {
        this.menuBarBackDrop = true
        this.menuContents = true

      },

      handleMenuBarBackDrop() {
        this.menuBarBackDrop = false
        this.menuContents = false

      },


      handleSearchBackDrop(params) {

        if (params === "open") {
          !this.searchMobileView ? this.searchZIndex = "z-index:500;display:inline" : this.searchZIndex = "z-index:500"

          return this.searchBackDrop = true
        }
        this.searchInput = "";
        this.displaySearchContents = false;
        this.filteredSearchList = [];
        this.searchZIndex = "z-index:1"
        this.userIconMenu = true
        this.searchMobileView = true
        this.displayNavTwo = true
        return this.searchBackDrop = false



      },

      closeRestrictMessage() {
        this.restrictGuest = false

      },

      showSearchInput() {
        this.searchZIndex = "display:inline;z-index:500"
        this.searchMobileView = false
        this.searchBackDrop = true
        this.userIconMenu = false
        this.displayNavTwo = false
      },

      handleUserOwnMenu(params) {
        this.clickedMenu = params
        if (params === 'userImageFullNav') {

          this.userOwnMenuFullNav ? this.$refs.userOwnMenuFullNav.style = "display:none;height:0;transition:all 1s" : this.$refs.userOwnMenuFullNav.style = "display:flex;height:auto;transition:all 1s";

          this.dropIconDisplay = !this.dropIconDisplay
          this.userOwnMenuFullNav = !this.userOwnMenuFullNav
        }
        else if (params === "userImageMobileView" && this.$refs.userOwnMenuMobileView !== null) {

          this.userOwnMenuMobileView ? this.$refs.userOwnMenuMobileView.style = "display:none;height:0;transition:all 1s" : this.$refs.userOwnMenuMobileView.style = "display:flex;height:auto;transition:all 1s";


          this.dropIconDisplay = !this.dropIconDisplay
          this.userOwnMenuMobileView = !this.userOwnMenuMobileView

        }

        else {
          this.userOwnMenu ? this.userOwnMenuStyle = "display:none;height:0;transition:all 1s" : this.userOwnMenuStyle = "display:flex;height:auto;transition:all 1s";


          this.dropIconDisplay = !this.dropIconDisplay
          this.userOwnMenu = !this.userOwnMenu
        }


        this.backDrop = !this.backDrop

      },

      handleActiveLink(activeLink) {

        switch (activeLink) {
          case "Home":
            this.homeLink = this.activeLink
            this.profileLink = this.inActiveLink
            this.timelineLink = this.inActiveLink
            this.messageLink = this.inActiveLink
            this.newsFeedLink = this.inActiveLink
            this.notificationLink = this.inActiveLink
            this.$store.dispatch("handleDisplayFunctions", {
              activeLink: "Home",
              params: "activeLink"
            })

            break;

          case "userProfile":
            if (this.userData.userName === "Guest") {

              return this.restrictGuest = true
            }
            this.homeLink = this.inActiveLink
            this.profileLink = this.activeLink
            this.timelineLink = this.inActiveLink
            this.messageLink = this.inActiveLink
            this.newsFeedLink = this.inActiveLink
            this.notificationLink = this.inActiveLink
            break;
          case "Messages":
            if (this.userData.userName === "Guest") {

              return this.restrictGuest = true
            }
            this.homeLink = this.inActiveLink
            this.profileLink = this.inActiveLink
            this.timelineLink = this.inActiveLink
            this.messageLink = this.activeLink
            this.newsFeedLink = this.inActiveLink
            this.notificationLink = this.inActiveLink
            break;
          case "Timeline":
            if (this.userData.userName === "Guest") {

              return this.restrictGuest = true
            }
            this.homeLink = this.inActiveLink
            this.profileLink = this.inActiveLink
            this.timelineLink = this.activeLink
            this.messageLink = this.inActiveLink
            this.newsFeedLink = this.inActiveLink
            this.notificationLink = this.inActiveLink


            break;
          case "Newsfeed":
            if (this.userData.userName === "Guest") {

              return this.restrictGuest = true
            }
            this.homeLink = this.inActiveLink
            this.profileLink = this.inActiveLink
            this.timelineLink = this.inActiveLink
            this.messageLink = this.inActiveLink
            this.newsFeedLink = this.activeLink
            this.notificationLink = this.inActiveLink

            break;

          default:
            break;
        }


      },



      handlePushRoutes(linkName) {
        this.clickedLink = linkName
        if (this.userData.userName === "Guest") {

          return this.restrictGuest = true
        }
        this.$router.push({
          name: linkName,
          params: { userName: this.userData.userName },
        });


      },

      handleTextHover(params) {

        if (this.clickedLink === params) {

          return ""
        }

        return "nav-notification-hover"
      },

      handleNotifications(params) {
        this.clickedLink = "Notifications"
        if (this.userData.userName === "Guest") {

          return this.restrictGuest = true
        }
        if (params === "notificationsFullNav") {
          if (this.notificationStateFullNav) {
            this.$refs.notificationMenuFullNav.style = "display:none;height:0;transition:all 1s"
            this.notificationBackDrop = false
          } else {
            this.$refs.notificationMenuFullNav.style = "display:flex;height:auto;transition:all 1s"
            this.notificationBackDrop = true
          }

          this.notificationStateFullNav = !this.notificationStateFullNav
        }
        else {
          if (this.notificationState) {
            this.$refs.notificationMenu.style = "display:none;height:0;transition:all 1s"
            this.notificationBackDrop = false
          }
          else {
            this.$refs.notificationMenu.style = "display:flex;height:auto;transition:all 1s"
            this.notificationBackDrop = true
          }
        }
      },

      handleNotifyBackDrop() {
        this.notificationBackDrop = false
        this.$refs.notificationMenuFullNav.style = "display:none;height:0;transition:all 1s"
        this.$refs.notificationMenu.style = "display:none;height:0;transition:all 1s"
      },

      showMessages() {
        if (this.userData.userName === "Guest") {

          return this.restrictGuest = true
        } this.$router.push({
          name: "Messages",
          params: { userName: this.userData.userName },
        });

      },
      showFriends() {
        if (this.userData.userName === "Guest") {

          return this.restrictGuest = true
        } this.$router.push({
          name: "Friends",
          params: { userName: this.userData.userName },
        });

      },



      showNotificationDetails(notificationType, notificationId, userName, posterUserName) {
        this.soundNum--
        switch (notificationType) {

          case 'friend request':
            this.$router.push({
              name: "Friends",
              params: { userName: this.userData.userName },
            })
            break;
          case 'follow':
            this.$router.push({
              name: "Friends",
              params: { userName: this.userData.userName },
            })
            this.$store.dispatch("handleNotificationUpdate", {
              userName: this.userData.userName,
              notificationStatus: "Read",
              notificationType: 'follow'
            });
            break;

          case 'message':
            this.$store.dispatch("handleMessageViewStatus", {
              friendMessaged: userName,
              userName: this.userData.userName,
              messageViewStatus: "Read",
              showMessage: true
            });


            this.$router.push({
              name: "Messages",
              params: { userName: this.userData.userName },
            })
            break;

          case 'post':
            this.$router.push({
              name: "Timeline",
              params: { userName, Timeline: "Timeline" },
            })



            break;

          case 'likes':
            this.$router.push({
              name: "Timeline",
              params: { userName: posterUserName, Timeline: "Timeline" },
            })


            this.$store.dispatch("handleNotificationUpdate", {
              userName: this.userData.userName,
              notificationStatus: "Read",
              notificationType: 'likes'
            });
            break;

          case 'comment':
            this.$router.push({
              name: "Timeline",
              params: { userName: posterUserName, Timeline: "Timeline" },
            })

            this.$store.dispatch("handleNotificationUpdate", {
              userName: this.userData.userName,
              notificationStatus: "Read",
              notificationType: 'comment'
            });
            break;

          default:
            break;
        }



      },
      handleGender(userName) {

        for (const user in this.$store.state.users)
          if (this.$store.state.users[userName].gender === "male") {
            return "his"

          }

        return "her"
      },







      showDate(date) {
        const currentDate = Date.now();
        const dateStatus = currentDate - date;
        const minutes = Math.round(dateStatus / (1000 * 60));
        const hours = Math.round(dateStatus / (1000 * 60 * 60));
        const days = Math.round(dateStatus / (1000 * 60 * 60 * 24));
        const weeks = Math.round(dateStatus / (1000 * 60 * 60 * 24 * 7));
        const months = Math.round(dateStatus / (1000 * 60 * 60 * 24 * 7 * 12));
        const years = Math.round(dateStatus / (1000 * 60 * 60 * 365));

        if (minutes <= 0) {
          return "Just now";
        } else if (minutes < 60) {
          return minutes === 1 ? "1 minute ago" : minutes + " minutes ago";
        } else if (hours < 12) {
          return hours === 1 ? "1 hour ago" : hours + " hours ago";
        } else if (days < 7) {
          return days === 1 ? "1 day ago" : days + " days ago";
        } else if (weeks < 4) {
          return weeks === 1 ? "1 week ago" : weeks + " weeks ago";
        } else if (months < 12) {
          return months === 1 ? "1 month ago" : months + " mouths ago";
        } else {
          return years === 1 ? "1 year ago" : years + " years ago";
        }
      },
      handleFooterDisplay() {

        if (this.$store.state.displayFunctions.activeLink === "Messages") {
          return false
        }
        else if (this.$store.state.displayFunctions.activeLink === "Timeline" && this.$store.state.displayFunctions.photosCompOnScreen) {

          return false

        }
        else if (!this.$store.state.displayFunctions.loginPageUnmounted) {

          return false

        }

        return true
      },


      autoPosts(params, userName, userId, message) {
        switch (params) {
          case "message":
            const messageId = uuid.v1();
            this.$store.dispatch("handleSubmitMessage", {
              [messageId]: {
                userName: userName,
                friendMessaged: this.$store.state.userData.userName,
                userId,
                message,
                messageId,
                messageDate: Date.now(),
                messageStatus: "sent",
              },
            });

            this.$store.dispatch("handleNotifications", {
              userName: userName,
              friendUserName: this.$store.state.userData.userName,
              notificationId: uuid.v1(),
              notificationType: 'message',
              notificationStatus: "unRead",
              notificationDate: Date.now()
            });

            this.$store.dispatch("handleMessageViewStatus", {
              friendMessaged: this.$store.state.userData.userName,
              messageOnScreen: "off",
              userName,
              messageViewStatus: "unRead",
              showMessage: false,

            });
            break;



          case "follow":

            this.$store.dispatch("handleFollow", {
              friendUserName: this.userData.userName,
              userName,
              followState: "follow"
            });

            this.$store.dispatch("handleNotifications", {
              userName,
              friendUserName: this.userData.userName,
              notificationId: uuid.v1(),
              notificationType: 'follow',
              notificationStatus: "unRead",
              notificationDate: Date.now(),

            });
            this.$store.dispatch("handleActivities", {
              friendUserName: this.userData.userName,
              userName,
              activity: "followed",
              activityDate: Date.now(),
              activityId: uuid.v1()
            });




            break;

          case "Add Friend":

            this.$store.dispatch("handleFriendRequest", {
              friendUserName: this.userData.userName,
              userName,
              requestStatus: "Request Sent",
            });

            this.$store.dispatch("handleNotifications", {
              userName,
              friendUserName: this.userData.userName,
              notificationId: uuid.v1(),
              notificationType: 'friend request',
              notificationStatus: "unRead",
              notificationDate: Date.now(),

            });

            this.$store.dispatch("handleActivities", {
              userName,
              friendUserName: this.userData.userName,
              activity: "Friend request",
              activityDate: Date.now(),
              activityId: uuid.v1()
            });

            break;


          default:
            break;
        }


        this.autoPostCounter++


        return "play"

      },




    },



    computed: {


      filteredSearchList() {

        let filteredSearchList = this.allUsers.sort(function (a, b) {
          var nameA = a.userName.toUpperCase();
          var nameB = b.userName.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        }).filter((user) => {
          return (
            user.userName
              .toLowerCase()
              .indexOf(this.searchInput.toLowerCase()) !== -1
          );
        })

        this.filteredSearchLists = filteredSearchList.filter((user) => user.userName !== this.$store.state.userData.userName)


        return this.filteredSearchLists
      },

      searchNotFound() {

        if (this.filteredSearchLists.length) {
          return false

        }
        return true
      },

      updateUserData() {
        const userData = this.$store.state.userData
        this.userData = this.$store.state.userData
        this.storeData = this.$store.state


        if (this.$store.state.displayFunctions.newAccount && this.autoPostCounter < 1) {

          setTimeout(() => {
            this.autoPosts("message", "Ivy", "5c8ef170-db3a-11eb-af32-47b0df65ae76", "hello")

          }, 10000);

          setTimeout(() => {
            this.autoPosts("message", "Sophie", "5c8ef170-db3a-11eb-af32-47b0df65ae76", `hello ${this.userData.userName}, How are you `)

          }, 15000);

          setTimeout(() => {
            this.autoPosts("message", "Ada", "5c8ef170-db3a-11eb-af32-47b0df65ae76", `hi ${this.userData.userName}`)

          }, 25000);



          setTimeout(() => {
            this.autoPosts("Add Friend", "Ivy", "5c8ef170-db3a-11eb-af32-47b0df65ae76")

          }, 20000);

          setTimeout(() => {
            this.autoPosts("Add Friend", "Sophie", "5c8ef170-db3a-11eb-af32-47b0df65ae76")

          }, 35000);

          setTimeout(() => {
            this.autoPosts("Add Friend", "Ada", "5c8ef170-db3a-11eb-af32-47b0df65ae76")

          }, 45000);

          setTimeout(() => {
            this.autoPosts("follow", "Ivy", "5c8ef170-db3a-11eb-af32-47b0df65ae76")

          }, 20000);

          setTimeout(() => {
            this.autoPosts("follow", "Sophie", "5c8ef170-db3a-11eb-af32-47b0df65ae76")

          }, 35000);

          setTimeout(() => {
            this.autoPosts("follow", "Ada", "5c8ef170-db3a-11eb-af32-47b0df65ae76")

          }, 45000);



          setTimeout(() => {

            this.$store.dispatch("handlePublishPost", {
              ["9b687760-dc19-11eb-9e4e-33a1151joshc9e"]: {
                userName: "Nova",
                userId: "89045af0-d9c9-11eb-ba8c-e9a262a433df",
                views: [],
                postId: "9b687760-dc19-11eb-9e4e-33a1151joshc9e",
                datePosted: Date.now(),
                posts: "When your Need crushes your Desire",
                likes: [],
                unLikes: [],
                posterComment: "",
                comments: [],
                postStyle: "text-theme-default",
                postImages: [{ imageUrl: "", imageId: "" }],
                postVideos: { videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4", videoId: "33a1151joshc9e", videoAutoplay: false },

              },

            });
          }, 50000);



          this.$store.dispatch("handleDisplayFunctions", {
            newAccount: false,
            params: "newAccount"
          });


        }




        let allUsers = []
        this.searchInput.length ? this.displaySearchContents = true : this.displaySearchContents = false

        for (let userName in this.$store.state.allUsers) {
          allUsers = [...allUsers, { userName }]


        }

        this.allUsers = allUsers

        let notifications = []
        let counter = 0;
        let unDuplicatedNotifications = this.userData.notifications
        for (const notificationId in this.userData.notifications) {
          for (const noticeId in unDuplicatedNotifications) {
            if (this.userData.notifications[notificationId].notificationType !== "message" || this.userData.notifications[notificationId].notificationType !== "post") {
              if (this.userData.notifications[notificationId].notificationType === unDuplicatedNotifications[noticeId].notificationType &&
                this.userData.notifications[notificationId].posterUserName === unDuplicatedNotifications[noticeId].posterUserName &&
                this.userData.notifications[notificationId].userName === unDuplicatedNotifications[noticeId].userName &&
                this.userData.notifications[notificationId].commenterUserName === unDuplicatedNotifications[noticeId].commenterUserName

              ) {



                counter++
                if (counter > 1) {


                  delete unDuplicatedNotifications[noticeId]
                }

              }
            }
          }

          counter = 0
        }


        for (const notificationId in unDuplicatedNotifications) {


          notifications = [...notifications, this.userData.notifications[notificationId]]

          this.notifications = notifications
        }


        this.notifications = this.notifications.filter((user) => user.userName !== this.userData.userName).reverse()

        this.$store.dispatch("handleMessageStatus", {
          userName: this.userData.userName,
          params: "received"
        });


        let messageStatus = {}
        for (let messageUserName in this.userData.messageStatus) {
          if (this.userData.messageStatus[messageUserName].messageViewStatus === "unRead") {
            for (let messageId in this.userData.messages[messageUserName]) {
              if (this.userData.messages[messageUserName][messageId].messageStatus === "received") {


                messageStatus = { ...messageStatus, [messageId]: { friendMessaged: this.userData.messages[messageUserName][messageId].userName } }


              }



            }

          }


        }

        this.newMessageCount = Object.keys(messageStatus).length

        if (this.$store.state.displayFunctions.activeLink.length) {
          this.handleActiveLink(this.$store.state.displayFunctions.activeLink)

        }

        let timelineCounter = [];

        for (const postId in this.$store.state.newsFeed) {
          if (!this.$store.state.newsFeed[postId].views.includes(this.userData.userName) && this.$store.state.newsFeed[postId].userName !== this.userData.userName) {
            timelineCounter = [...timelineCounter, { userName: this.$store.state.newsFeed[postId].userName }]
          }
        }

        this.timelineCount = timelineCounter.length


        const notificationCount = this.notifications.filter((noticeStatus) => noticeStatus.notificationStatus === "unRead")



        this.notificationCount = notificationCount.length

        if (this.notificationCount > this.soundNum) {
          setTimeout(() => {


            var promise = document.getElementById('newAlert').play()


            this.soundNum = this.notificationCount
          }, 500);

        }



        if (this.userData.friends.length) {
          this.friendsList = this.userData.friends.map((user) => user.userName)
        }

        let login = true
        if (this.$store.state.userData.userName === "Guest") {
          login = true
          this.logout = false
        } else {
          login = false
          this.logout = true

        }
        return login
      }

    }




  }
</script>



<style>



</style>